import { useMutation } from '@tanstack/react-query';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useFetch } from '@/modules/common';

import { CreateOverlayBody, OverlayUploadUrlData } from '../types';

export function useCreateOverlay() {
  const fetchClient = useFetch();

  const uploadUrlDataMutation = useMutation<
    OverlayUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient('/overlays/upload-url', {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ imageUploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: imageUploadUrl,
      });
    },
  });

  const createOverlayMutation = useApiMutation<CreateOverlayBody>('/overlays', {
    method: 'POST',
  });

  return { uploadUrlDataMutation, createOverlayMutation } as const;
}
